"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.18 18.57a7.82 7.82 0 1 1 15.64 0 7.82 7.82 0 0 1-15.64 0Zm1.596 9.65c1.726-.095 3.785-.156 6.224-.156 2.438 0 4.498.061 6.223.156 5.052.277 8.794 4.064 9.444 9.036.34 2.594.595 5.466.515 7.902-.064 1.922-1.492 3.379-3.374 3.594-.94.107-2.17.218-3.756.31-.284 3.3-.723 7.316-1.362 10.612-.283 1.458-1.293 2.72-2.816 3.07-1.15.264-2.775.506-4.874.506-2.1 0-3.725-.242-4.875-.506-1.523-.35-2.533-1.612-2.816-3.07-.64-3.296-1.077-7.312-1.362-10.612a68.157 68.157 0 0 1-3.755-.31c-1.882-.215-3.31-1.672-3.374-3.595-.08-2.434.175-5.306.514-7.901.65-4.972 4.392-8.76 9.444-9.036Z",
    fill: "#B3AEA3"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#fff"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgUser);
var _default = exports["default"] = Memo;